import { addEvent, Throttle } from '../utils/events';
import { smoothScroll, fadeIn, fadeOut } from '../utils/html';

export class BackToTop {

  /**
   * @param {Number} marginBottom Number of pixels to offset vertically from the bottom edge.
   * @param {Number} marginRight  Number of pixels to offset horizontally from the right edge.
   */
  constructor(marginBottom, marginRight) {
    this.cssClass = 'back-to-top';
    this.selector = `.${ this.cssClass }`;
    this.marginBottom = marginBottom;
    this.marginRight = marginRight;
    this.magicNumberForScrollTopTrigger = 100;
    this.magicNumberForScrollThrottling = 100;
    this.isTouchDevice = (('ontouchstart' in window) || window.DocumentTouch);
    if (!this.isEverythingOk()) {
      return;
    }
    this.init();
  }

  init() {
    this.scrollingElement = document.scrollingElement || document.documentElement;
    this.backToTop = document.querySelector(this.selector);
    if (this.backToTop) {
      return;
    }
    this.backToTop = document.createElement('div');
    if (this.marginBottom || this.marginRight) {
      if (this.marginBottom) {
        this.backToTop.style.marginBottom = `${ this.marginBottom }px`;
      }
      if (this.marginRight) {
        this.backToTop.style.marginRight = `${ this.marginRight }px`;
      }
    }
    if (!this.backToTop.classList.contains(this.cssClass)) {
      this.backToTop.classList.add(this.cssClass);
    }
    this.backToTop.innerHTML = '<i class="fa fa-angle-up fa-2x"></i>';
    this.scrollingElement.appendChild(this.backToTop);
    this.bindEvents();
    this.toggleBackToTop();
  }

  /**
   * Bind a throttled event handler to the window scroll event
   * to check whether the back to top element should be displayed or not.
   * Also binds the click event of the back to top element itself to the scrollToTop method.
   */
  bindEvents() {
    this.windowScroll = new Throttle(this.toggleBackToTop.bind(this), this.magicNumberForScrollThrottling);
    addEvent(window, 'scroll', this.windowScroll.trigger);
    addEvent(this.backToTop, 'touchstart', this.scrollToTop.bind(this));
    addEvent(this.backToTop, 'click', this.scrollToTop.bind(this));
  }

  /**
   * Determines whether the back to top element should be displayed or not.
   * The back to top element will be displayed when the window has been scrolled 100 pixels.
   */
  toggleBackToTop() {
    if (this.scrollingElement.scrollTop > this.magicNumberForScrollTopTrigger) {
      fadeIn(this.backToTop, 'inline');
    } else {
      fadeOut(this.backToTop);
    }
  }

  /**
   * Scrolls the document body back to the top using a smooth animation.
   */
  scrollToTop(event) {
    event.preventDefault();
    if (this.isTouchDevice) {
      this.scrollingElement.scrollTop = 0;
    } else {
      smoothScroll(this.scrollingElement, { axis: 'vertical' });
    }
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    // Ensure that any custom margins are integers
    if ((this.marginBottom && !Number.isInteger(this.marginBottom)) ||
      (this.marginRight && !Number.isInteger(this.marginRight))) {
      console.warn('CommonUI - Back to Top - Custom margins must be valid integers.');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */

}

/**
 * Creates a new "Back to Top" instance.
 * Allows an optional config to be specified for setting of bottom and/or right margins.
 * @param  {Object} config
 */
export default function initBackToTop(config = {}) {
  const { marginBottom = null, marginRight = null } = config;
  return new BackToTop(marginBottom, marginRight);
}



// WEBPACK FOOTER //
// ./js/components/BackToTop.js